import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import MuiCardHeader from '@mui/material/CardHeader';

const useStyles = makeStyles(theme => ({
  titleStyle: props => {
    return {
      fontWeight: '700',
      color: theme.palette.text.primary,
      ...(props.titleStyle || {}),
    };
  },
  subHeaderStyle: props => {
    return {
      paddingRight: 0,
      color: theme.palette.text.primary,
      ...(props.textStyle || {}),
    };
  },
}));

const CardHeader = ({ textStyle, titleStyle, ...props }) => {
  const styles = useStyles({ textStyle, titleStyle });
  return (
    <MuiCardHeader
      {...props}
      classes={{ subheader: styles.subHeaderStyle, title: styles.titleStyle }}
    />
  );
};

CardHeader.propTypes = {
  ...MuiCardHeader.propTypes,
  textStyle: PropTypes.object,
  titleStyle: PropTypes.object,
};

export default CardHeader;
